(function () {
    'use strict';

    angular.module("imApp").factory("productCompositionLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductCompositionLanguages: function (parms) {
                return $ihttp.post({
                    method: 2708,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2709,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
